import { render } from "./TwilioWorkingTimeEditor.vue?vue&type=template&id=1abff711"
import script from "./TwilioWorkingTimeEditor.vue?vue&type=script&lang=js"
export * from "./TwilioWorkingTimeEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__